import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EChartOption, ECharts } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { MultiDimensionBarService } from './multi-dimension-bar.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';
import { axisLabelRotate } from './multi-dimension-bar-interface';



@Component({
  selector: 'bcac-multi-dimension-bar',
  templateUrl: './multi-dimension-bar.component.html',
  styleUrls: ['./multi-dimension-bar.component.scss']
})
export class MultiDimensionBarComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private multiDimensionBarService: MultiDimensionBarService,
    private chartOptionService: ChartOptionService,
    private chartResizeServcie: ChartResizeService
  ) { }

  chartTitle = {
    show: true,
    label: '图表标题'
  };

  // 布局设置
  // cardpadding
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = '';

  // eachrt图表元素
  chartBackgroundColor: string = "#fff";
  chartColors: string[] = this.chartOptionService.getChartColors("default");
  chartTitles = this.chartOptionService.getChartTitle();
  chartLegend = this.chartOptionService.getChartLegend();
  chartGrid: EChartOption.Grid = this.commonService.changeFontSize().interval;
  chartxAxis: EChartOption.XAxis[] = this.multiDimensionBarService.getChartxAxis();
  chartyAxis: EChartOption.YAxis[] = this.chartOptionService.getChartyAxis(1);
  chartVisualMap = this.multiDimensionBarService.getPiecewiseVisualMap();
  barChartSeries: EChartOption.Series = this.multiDimensionBarService.getDefaultBarSeries();
  chartTooltip: EChartOption.Tooltip = this.multiDimensionBarService.getAxisChartWithMultiDimensionTooltip();
  chartTextStyle: EChartOption.TextStyle = this.chartOptionService.getTextStyle();
  chartSeriesList: EChartOption.Series[] = [];

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    title: this.chartTitles,
    legend: this.chartLegend,
    grid: this.chartGrid,
    xAxis: this.chartxAxis,
    yAxis: this.chartyAxis,
    visualMap: this.chartVisualMap,
    tooltip: this.chartTooltip,
    color: this.chartColors,
    series: this.chartSeriesList,
    textStyle: this.chartTextStyle
  };

  initOpts = this.chartOptionService.getInitOpts();
  optionInit: ECharts;
  onOptionInit(ec) {
    this.optionInit = ec;
  }


  options;
  // echart配置项
  initEchart() {
    this.options = this.chartOption;
  }

  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true);
    }
  }

  // 接口区
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.multiDimensionBarService.changeChartTitleDark(this, darkMode);
    this.multiDimensionBarService.chartBackgroundColorDarkMode(this.chartBackgroundColor);
    this.multiDimensionBarService.xAxisDarkMode(this.chartxAxis);
    this.multiDimensionBarService.yAxisDarkMode(this.chartyAxis);
    this.multiDimensionBarService.colorsDarkMode(this.chartColors);
    this.multiDimensionBarService.legendDarkMode(this.chartLegend);
    this.multiDimensionBarService.seriesDarkMode(this.barChartSeries);
  }

  // dimension
  @Input()
  set bcacDimensionName(dimensionName: string[]) {
    this.multiDimensionBarService.setSeriesDimensionName(this.barChartSeries, dimensionName, this.chartTooltip);
  }

  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.multiDimensionBarService.setSmallModeGrid(this.chartGrid);
      this.multiDimensionBarService.setSmallModePadding(this);
    }
  }

  legendPosition = "right";
  @Input()
  set bcacLegendPosition(legendPosition: string) {
    this.legendPosition = legendPosition;
    this.multiDimensionBarService.setLegendPosition(this.chartGrid, this.chartLegend, legendPosition);
  }

  @Input()
  set bcacTitleSwitch(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }
  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }
  @Input()
  set bcacXaxisName(xAxisname: string) {
    this.multiDimensionBarService.setXaxisName(this.chartxAxis, xAxisname);
  }
  @Input()
  set bcacYaxisName(yAxisName: string) {
    this.multiDimensionBarService.setYaxisName(this.chartyAxis, yAxisName);
  }
  @Input()
  set bcacYnameGap(yNameGap: number) {
    this.multiDimensionBarService.setYnameGap(this.chartyAxis, yNameGap);
  }

  @Input()
  set bcacColors(colorList: string[]) {
    this.multiDimensionBarService.chartColorsChange(this.chartColors, colorList);
  }

  @Input()
  set bcacSeriesBackgroundShow(show: boolean) {
    this.multiDimensionBarService.setSeriesBackgroundShow(show, this.barChartSeries);
  }

  legendDataList;
  @Input()
  set bcacChartData(chartData: any) {
    let legendDataList = [];
    if (chartData && chartData.hasOwnProperty('data') && chartData.data.hasOwnProperty('seriesName')) {
      chartData.data.seriesName.forEach(e => {
        legendDataList.push(
          {
            label: e.name,
            value: e.name,
            checked: true
          }
        )
      })
    }
    this.legendDataList = legendDataList;
    this.multiDimensionBarService.buildSeries(chartData, this.chartVisualMap, this.chartSeriesList, this.chartxAxis, this.barChartSeries)
    this.updateOption();
  }

  legendChange(e) {
    this.multiDimensionBarService.topLegendChange(e, this.optionInit);
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  @Input()
  set bcacSeriesLabelSwitch(seriesLabelSwith: boolean) {
    if (seriesLabelSwith == false) {
      this.barChartSeries['label']['show'] = false;
    }
  }

  // x轴刻度间隔
  intervalData = [];
  intervalSelectedData;
  intervalSelectedDataChange(e: any) {
    this.multiDimensionBarService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  axisScaleChange(e: any) {
    this.multiDimensionBarService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  @Input()
  set bcacIntervalData(value: any[]) {
    this.intervalData = value;
  }

  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Input()
  set bcacYAxisMin(yAxisMin: number) {
    this.multiDimensionBarService.setYAxisMin(yAxisMin, this.chartyAxis);
  }

  @Input()
  set bcacYAxisMax(yAxisMax: number) {
    this.multiDimensionBarService.setYAxisMax(yAxisMax, this.chartyAxis);
  }

  @Input()
  set bcacYAxisInterval(yAxisInterval: number) {
    this.multiDimensionBarService.setYAxisInterval(yAxisInterval, this.chartyAxis)
  }

  @Input()
  set bcacYAxisMinInterval(minInterval: number) {
    this.multiDimensionBarService.setYAxisMinInterval(minInterval, this.chartyAxis)
  }

  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: axisLabelRotate) {
    this.multiDimensionBarService.changeXAxisLabelRotate(this.chartOption, xAxisLabelRotate);
    this.updateOption();
  }

  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: axisLabelRotate) {
    this.multiDimensionBarService.changeYAxisLabelRotate(this.chartOption, yAxisLabelRotate);
    this.updateOption();
  }


  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  ngOnInit() {
    this.initEchart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeServcie.autoResizeAdapt(this.optionInit, this.options)
    })
  }

}
